angular.module('impactx.backImg', []).directive('ixBackImg', [function() {
    return {
        scope: {
            image: '=',
            bestfit: '=',
            customClasses: "="
        },
        templateUrl: 'shared/backgroundimage/template/background.tmpl.html',
        link: {
            post: function(scope) {
                if (scope && scope.image) {
                    scope.image = toUrlWithoutWhitespace(scope.image);
                }

                scope.forInternetExplorer = !window.CSS || !CSS.supports('object-fit', 'cover');
            }
        }
    }
}]);
